import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ResumenVuelos.css";
import './SharedLoading.css';
import API_BASE_URL from "../config";

const ResumenVuelosPage = () => {
  const [vuelosLlegadas, setVuelosLlegadas] = useState([]);
  const [vuelosSalidas, setVuelosSalidas] = useState([]);
  const [loadingPage, setLoadingPage] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
const [serviciosVuelo, setServiciosVuelo] = useState([]);
const [tituloModal, setTituloModal] = useState("");
const [colaboradoresMap, setColaboradoresMap] = useState({});


const token = useSelector((state) => state.auth.token);
  const decoded = token ? jwtDecode(token) : null;
    const estacionUsuario = decoded?.estacion?.trim().toUpperCase();

  const llegadaRef = useRef(null);
  const salidaRef = useRef(null);


  

  

  useEffect(() => {
  const obtenerResumenVuelos = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/vuelos/resumen-vuelos`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const vuelos = res.data;
      setVuelosLlegadas(vuelos.filter(v => v.tipoService === "LLEGADAS"));
      setVuelosSalidas(vuelos.filter(v => v.tipoService === "SALIDAS"));
    } catch (error) {
      console.error("❌ Error al obtener resumen de vuelos:", error);
      toast.error("Error al cargar resumen de vuelos");
    } finally {
      setLoadingPage(false);
    }
  };

  obtenerResumenVuelos();
  const interval = setInterval(obtenerResumenVuelos, 300000); // cada 5 minutos
  return () => clearInterval(interval);
}, [token]);

const abrirModalServicios = async (vuelo) => {
  try {
    const { noVuelo, fechaInput, aerolinea, origenVuelo, destinoVuelo } = vuelo;

    const res = await axios.get(
      `${API_BASE_URL}api/vuelos/resumen-vuelos/${noVuelo}/${fechaInput}/${aerolinea}/${estacionUsuario}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const servicios = res.data;

    // Obtener los noColaborador únicos y consultar sus siglas
    const unicos = [...new Set(servicios.map((s) => s.noColaborador).filter(Boolean))];
    await Promise.all(unicos.map(obtenerColaborador));

    setServiciosVuelo(servicios);
    setTituloModal(`Servicios del vuelo ${aerolinea} ${noVuelo}     ${origenVuelo} ➡️ ${destinoVuelo}`);
    setModalVisible(true);
  } catch (err) {
    console.error("❌ Error al obtener servicios del vuelo:", err);
    toast.error("Error al cargar los servicios del vuelo");
  }
};


const obtenerColaborador = async (noColaborador) => {
  if (!noColaborador) return;

  if (!colaboradoresMap[noColaborador]) {
    try {
      const res = await axios.get(`${API_BASE_URL}api/operadores/${noColaborador}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const siglas = res.data?.siglas || "-";
      setColaboradoresMap((prev) => ({
        ...prev,
        [noColaborador]: siglas,
      }));
    } catch (err) {
      console.error("Error al obtener colaborador", err);
      setColaboradoresMap((prev) => ({
        ...prev,
        [noColaborador]: "-",
      }));
    }
  }
};




  const claseTiempo = (hora) => {
    const ahora = moment();
    const llegada = moment(hora);
    const diffMin = llegada.diff(ahora, "minutes");

    if (diffMin >= 0 && diffMin <= 15) return "cercano-15";
    if (diffMin <= 30) return "cercano-30";
    if (diffMin <= 60) return "cercano-60";
    return "";
  };

  const obtenerBadgeHora = (hora) => {
    const ahora = moment();
    const llegada = moment(hora);
    const diffMin = llegada.diff(ahora, "minutes");

    let clase = "dot-normal";

    if (diffMin >= 0 && diffMin <= 15) clase = "dot-urgente";
    else if (diffMin <= 30) clase = "dot-alerta";

    return (
      <span className="badge-hora">
        <span className={`badge-dot ${clase}`} />
        {llegada.format("HH:mm")}
      </span>
    );
  };

  
  

  useEffect(() => {
    const ahora = moment();
    const scrollToClosest = (vuelos, tipo, ref) => {
      const closestIndex = vuelos.findIndex((v) => {
        const hora =
          tipo === "LLEGADAS"
            ? moment(v.published_arrival_time)
            : moment(v.published_departure_time);
        return hora.isAfter(ahora);
      });

      if (closestIndex !== -1 && ref.current) {
        const row = ref.current.querySelectorAll("tbody tr")[closestIndex];
        if (row) row.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    };

    scrollToClosest(vuelosLlegadas, "LLEGADAS", llegadaRef);
    scrollToClosest(vuelosSalidas, "SALIDAS", salidaRef);
  }, [vuelosLlegadas, vuelosSalidas]);

  const renderTabla = (vuelos, tipo, ref) => (
    <div className="tabla-resumen">
      <h2>{tipo}</h2>
      <div className="scroll-wrapper" ref={ref}>
        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Vuelo</th>
              <th>Origen</th>
              <th>Destino</th>
              <th>Servicios</th>
              <th>Tipo</th>
            </tr>
          </thead>
          <tbody>
            {vuelos.map((vuelo, idx) => {
              const hora =
                tipo === "LLEGADAS"
                  ? moment(vuelo.published_arrival_time)
                  : moment(vuelo.salida_time);

              const claseFila =
                tipo === "LLEGADAS"
                  ? claseTiempo(vuelo.published_arrival_time)
                  : claseTiempo(vuelo.salida_time);

              return (
                <tr
  key={`${vuelo.noVuelo}-${vuelo.fechaInput}-${vuelo.aerolinea}`}
  className={claseFila}
  onClick={() => abrirModalServicios(vuelo)}
>
                  <td>{idx + 1}</td>
                  <td>{vuelo.aerolinea} {vuelo.noVuelo}</td>
                  <td>{vuelo.origenVuelo}</td>
                  <td>{vuelo.destinoVuelo}</td>
                  <td>{vuelo.totalServicios}</td>
                  <td>{vuelo.int_nac}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );

  if (loadingPage) {
    return (
      <div className="resumen-vuelos-container">
        <div className="page-loading-overlay">
          <div className="page-loading-spinner" />
          <p className="page-loading-text">Cargando gestión de vuelos...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="resumen-vuelos-container">
      {renderTabla(vuelosLlegadas, "LLEGADAS", llegadaRef)}
      {renderTabla(vuelosSalidas, "SALIDAS", salidaRef)}
      {modalVisible && (
  <div className="custom-modal-overlay" onClick={() => setModalVisible(false)}>
    <div className="custom-modal" onClick={(e) => e.stopPropagation()}>
      <div className="custom-modal-header">
        <span className="title">{tituloModal}</span>
        <button className="close-button" onClick={() => setModalVisible(false)}>
          ✕
        </button>
      </div>

      <div className="custom-modal-body">
        {serviciosVuelo.length === 0 ? (
          <p>No hay servicios registrados para este vuelo.</p>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Pasajero</th>
                <th>Asiento</th>
                <th>Colaborador</th>
                <th>Hora Inicio</th>
                <th>Hora Fin</th>
                <th>Status</th>
                <th>Tipo</th>
                {
      serviciosVuelo.some((s) => s.statusServicio === 'STDBY') && (
        <th>Checkpoint</th>
      )
    }
              </tr>
            </thead>
            <tbody>
              {serviciosVuelo.map((s, idx) => (
                <tr key={s.noServicio}>
                  <td>{idx + 1}</td>
                  <td>{s.nombrePax || "-"}</td>
                  <td>{s.noAsiento || "-"}</td>
                  <td>{colaboradoresMap[s.noColaborador] || s.noColaborador || "-"}</td>
                  <td>{s.horaInicio?.substring(11, 16) || "-"}</td>
                  <td>{s.horaFin?.substring(11, 16) || "-"}</td>
                  <td>{s.statusServicio}</td>
                  <td>{s.tipoSilla || "-"}</td>
                  {s.statusServicio === 'STDBY' && (
        <td>{s.checkpoint || "-"}</td>
      )}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default ResumenVuelosPage;
